module.exports = __webpack_public_path__ + "img/img (8).be6bc89b.png";